import {
    GET_FEATURES_FAIL,
    GET_FEATURES_SUCCESS,
    ADD_FEATURE_SUCCESS,
    ADD_FEATURE_FAIL,
    UPDATE_FEATURE_SUCCESS,
    UPDATE_FEATURE_FAIL,
    DELETE_FEATURE_SUCCESS,
    DELETE_FEATURE_FAIL,
   
} from "./actionTypes";

const INIT_STATE = {
    features: [],
    error: {},
    loading: true
}

const featureReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_FEATURES_SUCCESS:
            return {
                ...state,
                features: action.payload,
                loading: false
            };

        case GET_FEATURES_FAIL:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case ADD_FEATURE_SUCCESS:
            return {
                ...state,
                //features: [action.payload, ...state.features],
                features: action.payload ? [action.payload, ...state.features] : [...state.features],
            };

        case ADD_FEATURE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case UPDATE_FEATURE_SUCCESS:
            return {
                ...state,
                /*features: state.features.map(feature =>
                    feature.id.toString() === action.payload.id.toString()
                        ? { feature, ...action.payload }
                        : feature
                ),*/
                features: state.features.map(feature =>
                    feature.id.toString() === action.payload.id.toString()
                        ? { ...feature, ...action.payload } // <-- juste fusionner
                        : feature
                ),
            };

        case UPDATE_FEATURE_FAIL:
            return {
                ...state,
                error: action.payload,
            };

        case DELETE_FEATURE_SUCCESS:
            return {
                ...state,
                features: state.features.filter(
                    feature => feature.uid.toString() !== action.payload.uid.toString()
                ),
            };

        case DELETE_FEATURE_FAIL:
            return {
                ...state,
                error: action.payload,
            };
       
        default:
            return state
    }
}

export default featureReducer;